export default "__VITE_ASSET__7dcxJBqE__"